<div [@fade]="state" class="loading">
      <p-progress-spinner strokeWidth="3" ariaLabel="loading" fill="transparent" animationDuration=".7s" [style]="{ width: '50px', height: '50px', stroke: '#000' }" />
</div>
